<template>
  <div class="page-report">
    <HeaderMegaposData/>
    <div class="page-header align-items-start min-vh-100 my-transacions">
      <span class="mask bg-white"></span>
      <div class="container">
        <div class="row">
          <div class="col-lg-12 col-md-12 col-12 mx-auto mt-4">
            <div class="row">
              <h2>Daily Revenue</h2>
            </div>
            <FormSearch
              :searchParameter="form"
              :onChangeSearchParameter="onChangeSearchParameter"
              :selectAllBranch="false"
              :hidePhysicalBranchFilter="false"
              :totalDaySelect="31"
              @reload-data="runReport"
              @export="exportFile"
            ></FormSearch>
            <div
              class="row mt-4"
              style="min-height: 1120px"
              v-if="isLoadDone"
              v-show="isLoadDoneDataTable"
            >
              <div class="col-12">
                <div>
                  <div class="px-0 pb-2">
                    <div class="d-flex justify-content-end align-items-center mb-3">
                      <label class="global-search mb-0">Search:
                        <input
                          type="search"
                          v-model="searchKeyword"
                          @input="onKeywordSearch"
                        />
                      </label>
                    </div>
                    <div class="p-0 custom-table">
                      <table
                        class="table align-items-center mb-0 dataTable"
                        ref="dataTable"
                      >
                        <thead>
                          <tr>
                            <th class="text-center font-weight-bolder">
                              <div class="pt-4">Row No</div>
                            </th>
                            <template
                              v-for="(item, index) in headersData"
                              :key="index"
                            >
                              <th
                                class="text-center font-weight-bolder position-relative"
                              >
                                <div
                                  class="pt-4"
                                  style="position: unset"
                                  :class="[
                                    !!item.hasSortBy
                                      ? 'wrapper-sortby pointer'
                                      : '',
                                    ESortDirectionSelect.idx == index + 1
                                      ? ESortDirectionSelect.direction ===
                                        ESortDirection.Desc
                                        ? 'sort-desc'
                                        : 'sort-asc'
                                      : '',
                                  ]"
                                  @click="
                                    handleChangeSortColumn(
                                      index + 1,
                                      item.field
                                    )
                                  "
                                >
                                  {{ item.label }}
                                </div>
                              </th>
                            </template>
                          </tr>
                          <tr>
                            <th class="text-center font-weight-bolder">
                              <input
                                v-model="columnSearch[0]"
                                @input="searchColumn(0)"
                              />
                            </th>
                            <template
                              v-for="(item, index) in headersData"
                              :key="index"
                            >
                              <th class="text-center font-weight-bolder">
                                <input
                                  v-model="columnSearch[index + 1]"
                                  @input="searchColumn(index + 1)"
                                />
                              </th>
                            </template>
                          </tr>
                        </thead>
                        <tbody v-if="days && days.length">
                          <tr v-for="(value, key) in days" :key="key">
                            <td class="text-right text-xss w-5">
                              {{ rowOffset + key + 1 }}
                            </td>
                            <td class="text-left text-xss">{{ value?.date_format }}</td>
                            <td class="text-right text-xss">{{ formatPrice(value?.sub_total) }}</td>
                            <td class="text-right text-xss">{{ formatPrice(value?.discount) }}</td>
                            <td class="text-right text-xss">{{ formatPrice(value?.service_charge) }}</td>
                            <td class="text-right text-xss">{{ formatPrice(value?.gst) }}</td>
                            <td class="text-right text-xss">{{ formatPrice(value?.redemption) }}</td>
                            <td class="text-right text-xss">{{ formatPrice(value?.rounding) }}</td>
                            <td class="text-right text-xss">{{ formatPrice(value?.total) }}</td>
                            <td class="text-right text-xss">{{ formatPrice(value?.total_wo_gst) }}</td>
                            <td class="text-right text-xss">{{ formatPrice(value?.tips) }}</td>
                            <td class="text-right text-xss">{{ value?.bill_count }}</td>
                            <td class="text-right text-xss">{{ formatPrice(value?.bill_avg) }}</td>
                            <td
                              v-for="method in paymentMethods"
                              :key="method"
                              class="text-right text-xss"
                            >
                              {{ formatPrice((value?.payment_methods || {})[method] || 0) }}
                            </td>
                            <td class="text-right text-xss">{{ formatPrice(value?.unallocated) }}</td>
                          </tr>
                        </tbody>
                        <tbody v-else class="no-data">
                          <tr>
                            <td :colspan="headersData.length + 1" class="text-left">No matching records found</td>
                          </tr>
                        </tbody>
                        <tfoot>
                          <tr class="total-row">
                            <td class="text-right text-xss">TOTAL</td>
                            <td class="text-left text-xss"></td>
                            <td class="text-right text-xss">{{ formatPrice(totals.sub_total) }}</td>
                            <td class="text-right text-xss">{{ formatPrice(totals.discount) }}</td>
                            <td class="text-right text-xss">{{ formatPrice(totals.service_charge) }}</td>
                            <td class="text-right text-xss">{{ formatPrice(totals.gst) }}</td>
                            <td class="text-right text-xss">{{ formatPrice(totals.redemption) }}</td>
                            <td class="text-right text-xss">{{ formatPrice(totals.rounding) }}</td>
                            <td class="text-right text-xss">{{ formatPrice(totals.total) }}</td>
                            <td class="text-right text-xss">{{ formatPrice(totals.total_wo_gst) }}</td>
                            <td class="text-right text-xss">{{ formatPrice(totals.tips) }}</td>
                            <td class="text-right text-xss">{{ totals.bill_count }}</td>
                            <td class="text-right text-xss">{{ formatPrice(totals.bill_avg) }}</td>
                            <td
                              v-for="method in paymentMethods"
                              :key="method"
                              class="text-right text-xss"
                            >
                              {{ formatPrice((totals.payment_methods || {})[method] || 0) }}
                            </td>
                            <td class="text-right text-xss">{{ formatPrice(totals.unallocated) }}</td>
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                  </div>

                  <div class="d-flex justify-content-between align-items-center mb-3 px-3 pt-3">
                    <div class="rows-per-page">
                      <span class="rows-per-page__label">Rows per page</span>
                      <div class="rows-per-page__control">
                        <select v-model="limit" @change="setLimitPerPage" class="rows-per-page__select">
                          <option :value="20">20</option>
                          <option :value="50">50</option>
                          <option :value="100">100</option>
                        </select>
                      </div>
                    </div>
                    <pagination
                      v-if="pagination.last_page > 1"
                      :pagination="pagination"
                      :current_page="pagination.current_page"
                      :last_page="pagination.last_page"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="position-fixed top-1 end-1 z-index-2 message-success">
        <material-snackbar
          v-if="snackbar === 'danger' || snackbar === 'success'"
          title=""
          date=""
          :description="message"
          :icon="{ component: 'campaign', color: 'white' }"
          :color="snackbar"
          :close-handler="closeSnackbar"
        />
      </div>
      <material-loading :active="loaderActive" />
    </div>
    <form
      :action="`${actionDownload}/merchant/analytics/daily-revenue/export`"
      method="POST"
    >
      <input type="hidden" name="merchantId" :value="merchantIdExport" />
      <input type="hidden" name="merchant_code" :value="merchantCode" />
      <input type="hidden" name="token" :value="token" />
      <input type="hidden" name="physical_branch_id" :value="form.physical_branch_id" />
      <input type="hidden" name="branch_id" :value="form.branch_id" />
      <input type="hidden" name="from_date" :value="from_date_export" />
      <input type="hidden" name="to_date" :value="to_date_export" />
      <input type="hidden" name="keyword" :value="searchKeyword" />
      <!--
        column_search is a map, and a form POST can only carry scalars — so each
        active column goes out as its own bracketed field. Without this the export
        would quietly ignore whatever the user had filtered on screen.
      -->
      <template v-for="(item, index) in headersData" :key="`exp-${index}`">
        <input
          type="hidden"
          :name="`column_search[${item.field}]`"
          :value="columnSearch[index + 1] || ''"
        />
      </template>
      <input type="hidden" name="action_export" :value="action_export" />
      <input type="hidden" name="action" value="export" />
      <input id="downloadFormDailyRevenue" type="submit" class="d-none" />
    </form>
  </div>
</template>

<script>
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import "bootstrap/dist/js/bootstrap.bundle";
import MaterialLoading from "@/components/MaterialLoading.vue";
import "bootstrap/js/dist/modal";
import "@vuepic/vue-datepicker/dist/main.css";
import moment from "moment";
import AnalyticsService from "../../services/analytics.service";
import CommonFunctionService from "../../services/commonFunction.service";
import { startOfMonth } from "date-fns";
import $ from "jquery";
import TokenService from "../../services/token.service";
import FormSearch from "./components/FormSearch.vue";
import Pagination from "@/components/Pagination.vue";
import HeaderMegaposData from "./components/HeaderMegaposData.vue";

export default {
  name: "daily-revenue-report",
  components: {
    MaterialSnackbar,
    MaterialLoading,
    FormSearch,
    Pagination,
    HeaderMegaposData,
  },
  data() {
    return {
      isLoadDone: false,
      isLoadDoneDataTable: false,
      token: TokenService.getLocalAccessToken(),
      actionDownload: process.env.VUE_APP_BASE_URL,
      merchantIdExport: localStorage.getItem("MERCHANT_ID", ""),
      merchantCode: localStorage.getItem("MERCHANT_CODE", ""),
      message: "",
      snackbar: null,
      loaderActive: false,
      days: null,
      paymentMethods: [],
      totals: {},
      form: {
        physical_branch_id: -1,
        branch_id: -1,
        from_date: moment(startOfMonth(new Date())),
        to_date: new Date(),
      },
      ESortDirectionSelect: {
        idx: null,
        field: "",
        direction: null,
      },
      ESortDirection: {
        Asc: "asc",
        Desc: "desc",
      },
      action_export: "csv",
      from_date_export: "",
      to_date_export: "",
      columnSearch: [],
      pagination: {},
      page: 1,
      // 50, not the usual 20: every date in the window now gets a row and the window
      // is capped at 31 days, so a whole month fits on one page instead of making the
      // reader page through a report they want to read top to bottom.
      limit: 50,
      searchTimer: null,
      searchKeyword: "",
      // Nothing loads until the user asks for it. This report scans a month of
      // transactions across every branch, so firing it on entry would spend that
      // work before anyone has chosen what they actually want to see.
      hasRun: false,
    };
  },
  computed: {
    /**
     * Payment columns are driven by the tenders the window actually contains, so the
     * header can't be a fixed list — a branch that never takes GrabFood shouldn't be
     * given an empty GrabFood column, and a new tender shouldn't need a code change.
     */
    headersData() {
      const base = [
        { label: "Day", field: "date_format", hasSortBy: true },
        { label: "SubTotal", field: "sub_total", hasSortBy: true },
        { label: "Discount", field: "discount", hasSortBy: true },
        { label: "Service Charge", field: "service_charge", hasSortBy: true },
        { label: "GST", field: "gst", hasSortBy: true },
        { label: "Redemption", field: "redemption", hasSortBy: true },
        { label: "Rounding", field: "rounding", hasSortBy: true },
        { label: "Total", field: "total", hasSortBy: true },
        { label: "Total Wo GST", field: "total_wo_gst", hasSortBy: true },
        { label: "Tips", field: "tips", hasSortBy: true },
        { label: "BillCNT", field: "bill_count", hasSortBy: true },
        { label: "BillAvg", field: "bill_avg", hasSortBy: true },
      ];

      this.paymentMethods.forEach((method) => {
        base.push({ label: method, field: method, hasSortBy: true });
      });

      base.push({ label: "Unallocated", field: "unallocated", hasSortBy: true });

      return base;
    },

    // Row numbers continue across pages rather than restarting at 1 each page.
    rowOffset() {
      return ((this.pagination.current_page || 1) - 1) * this.limit;
    },
  },
  created() {
    this.syncColumnSearchSize();
  },
  watch: {
    // The payment columns only exist once the first response lands, so unlike the
    // fixed-column reports the search model cannot be sized once in created() —
    // it has to grow with them, without dropping what the user already typed.
    paymentMethods() {
      this.syncColumnSearchSize();
    },
  },
  methods: {
    syncColumnSearchSize() {
      const size = this.headersData.length + 1;

      for (let i = this.columnSearch.length; i < size; i++) {
        this.columnSearch[i] = "";
      }

      this.columnSearch.length = size;
    },

    format(date) {
      return CommonFunctionService.formatDateShow(date);
    },

    formatPrice(price) {
      return (
        "$ " + Number(price || 0).toLocaleString("en-US", { minimumFractionDigits: 2 })
      );
    },

    exportFile(type = "csv") {
      this.action_export = type;
      this.from_date_export = this.dateFormat(this.form.from_date);
      this.to_date_export = this.dateFormat(this.form.to_date);
      setTimeout(() => {
        $("#downloadFormDailyRevenue").click();
      }, 150);
    },

    dateFormat(date) {
      if (date == null) {
        return null;
      } else {
        return moment(date).format("YYYY-MM-DD");
      }
    },

    onChangeSearchParameter(value, fieldName) {
      this.form[fieldName] = value !== null ? value : "-1";
    },

    closeSnackbar() {
      this.snackbar = null;
    },

    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },

    buildColumnSearch() {
      const search = {};
      this.headersData.forEach((header, index) => {
        const value = this.columnSearch[index + 1];
        if (
          header.field &&
          value !== undefined &&
          value !== null &&
          String(value).trim() !== ""
        ) {
          search[header.field] = String(value).trim();
        }
      });
      return search;
    },

    searchColumn() {
      // Debounce so we query the server once the user pauses typing; reset to
      // page 1 because the filtered result set (and its total) changes.
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.page = 1;
        this.getList(1);
      }, 500);
    },

    onKeywordSearch() {
      // Global search — same server round-trip as the per-column search.
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.page = 1;
        this.getList(1);
      }, 500);
    },

    handleChangeSortColumn(idx, field) {
      if (
        this.ESortDirectionSelect.idx &&
        this.ESortDirectionSelect.idx == idx
      ) {
        this.ESortDirectionSelect.direction =
          this.ESortDirectionSelect.direction === this.ESortDirection.Asc
            ? this.ESortDirection.Desc
            : this.ESortDirection.Asc;
      } else {
        this.ESortDirectionSelect = {
          idx: idx,
          field: field,
          direction: this.ESortDirection.Asc,
        };
      }

      // Sort on the server so it orders the whole result set, not just this page.
      this.getList(this.page);
    },

    runReport() {
      this.hasRun = true;
      // Back to page 1: the filters just changed, so the page the user was on no
      // longer points at the same rows.
      this.page = 1;
      this.getList(1);
    },

    getList(page) {
      // Belt and braces alongside having no mounted() hook. Pagination reaches in and
      // calls $parent.getList() directly, and the column-search and sort handlers call
      // it too, so the "only on Run" rule is stated here rather than left to depend on
      // no one ever adding a call site.
      if (!this.hasRun) {
        return;
      }

      this.showLoader();
      var dataForm = {
        physical_branch_id: this.form.physical_branch_id,
        branch_id: this.form.branch_id,
        from_date: this.dateFormat(this.form.from_date),
        to_date: this.dateFormat(this.form.to_date),
        page: page,
        column_search: this.buildColumnSearch(),
        keyword: this.searchKeyword,
        sort_field: this.ESortDirectionSelect.field,
        sort_type: this.ESortDirectionSelect.direction,
        limit: this.limit,
      };

      AnalyticsService.dailyRevenueReport(dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            const data = response.data.data;
            this.days = data.days;
            this.paymentMethods = data.payment_methods ?? [];
            // Footer totals span every filtered day, not just this page — paging must
            // not move the figure the merchant is reconciling against.
            this.totals = data.totals ?? {};
            this.pagination = {
              total: data.total,
              current_page: data.current_page,
              last_page: data.last_page,
              // <pagination> reads these to render the ±1 page links and enable Prev/Next.
              prev_page_url: data.prev_page_url,
              next_page_url: data.next_page_url,
            };
            this.page = this.pagination.current_page;

            if (
              this.pagination.current_page > this.pagination.last_page &&
              this.pagination.total > 0
            ) {
              this.page = 1;
              this.getList(this.page);
              return;
            }

            this.$router.push({
              query: Object.assign({}, this.$route.query, { page: this.page }),
            });

            this.isLoadDone = true;
            this.isLoadDoneDataTable = true;
            this.hideLoader();
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
            this.hideLoader();
          }
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.hideLoader();
          this.setTimeOutNotification();
        }
      );
    },

    setLimitPerPage() {
      // Reset to page 1 when changing limit
      this.page = 1;
      this.getList(1);
    },

    showLoader() {
      this.loaderActive = true;
    },

    hideLoader() {
      this.loaderActive = false;
    },
  },
};
</script>
<style scoped>
table thead th:not(:first-child) {
  padding-left: 10px !important;
  padding-right: 10px !important;
}

table thead th > span {
  position: relative;
}

input[type="search"] {
  border: none;
  background: transparent;
  margin: 0;
  padding: 7px 8px;
  font-size: 14px;
  color: inherit;
  border: 1px solid transparent;
  border-radius: inherit;
}

input[type="search"]::placeholder {
  color: #bbb;
  text-align: left;
  font-weight: normal;
}

input[type="search"]:focus {
  border-color: #72959d;
  outline: none;
  border: none;
  border-bottom: 2px solid #72959d;
}

tbody:not(.no-data) > tr:nth-child(2n + 1) {
  background: #f0f2f5;
}

tbody:not(.no-data) > tr:hover {
  background: #ebecee;
}

.custom-table :not(caption) > * > * {
  border-right-width: 1px !important;
}

.custom-table :not(caption) > * > *:first-child {
  border-left-width: 1px !important;
}

/* Empty-state ("No matching records found") cell: keep the same left/right grid
   borders as the data rows (the width-only rules above don't render on this
   single colspan cell). */
.custom-table tbody.no-data > tr > td {
  border-left: 1px solid #dee2e6 !important;
  border-right: 1px solid #dee2e6 !important;
}

tfoot tr.total-row {
  font-weight: bold;
  color: #222;
  background: #e9edf2;
}

tfoot tr.total-row td {
  border-top: 2px solid #dee2e6;
}

/* Horizontal scroll lives in the table region; the page scrolls vertically. */
.custom-table {
  overflow-x: auto;
}

/* Bootstrap only draws a *bottom* border on table cells, so without this the first
   header row has no line above it and the header looks cut off at the top. */
.custom-table thead tr:first-child th {
  border-top: 1px solid #dee2e6 !important;
}

/* Column search inputs, styled like POS Daily Collection */
.custom-table table.dataTable thead th input {
  width: 100%;
  box-sizing: border-box;
  padding: 5px 8px;
  border: 1px solid #d2d6da;
  font-size: 13px;
  color: #495057;
  font-weight: normal;
}

.custom-table table.dataTable thead th input:focus {
  outline: none;
  border-color: #72959d;
  box-shadow: 0 0 0 2px rgba(114, 149, 157, 0.15);
}

/* Global "Search:" box */
.global-search {
  font-size: 13px;
  font-weight: 600;
  color: #495057;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.global-search input {
  padding: 6px 12px;
  border: 1px solid #d2d6da;
  font-size: 13px;
  font-weight: normal;
  color: #495057;
  background: #fff;
  min-width: 220px;
}

.global-search input:focus {
  outline: none;
  border: 1px solid #72959d;
  box-shadow: 0 0 0 2px rgba(114, 149, 157, 0.15);
}

</style>
